import { render, staticRenderFns } from "./MilestoneCreateForm.vue?vue&type=template&id=235819ca&"
import script from "./MilestoneCreateForm.vue?vue&type=script&lang=js&"
export * from "./MilestoneCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports